/**
 * mad-video — attach a video source to a <video>: MP4 directly, HLS via hls.js
 * or native Safari HLS. Ported from the MAD Videos plugin (mediaSource.js).
 */

// Optimized for Bunny Stream
var HLS_CONFIG = {
  startLevel: 2,
  maxBufferLength: 30,
  maxMaxBufferLength: 60,
  maxBufferSize: 60 * 1000 * 1000,
  maxBufferHole: 0.5,
  lowLatencyMode: false,
};

function isHls(url, provider) {
  return provider === 'hls' || /\.m3u8(?:$|\?)/i.test(url || '');
}

/**
 * @param {HTMLVideoElement} video
 * @param {string}   url
 * @param {Object}   [options]
 * @param {string}   [options.provider] Provider resolved in PHP ('hls', 'mp4', …)
 * @param {boolean}  [options.lazy=false] HLS: only fetch the manifest until startLoad().
 *                                        MP4 / native HLS: set preload="none" on the element.
 * @param {Function} [options.onError]  Called when playback can't recover.
 * @returns {{hls: Object|null, startLoad: Function, destroy: Function}}
 * @throws {Error} when the source is HLS and the browser can't play HLS
 */
function attachSource(video, url, options) {
  options = options || {};
  var onError = options.onError || function () {};
  var noop = { hls: null, startLoad: function () {}, destroy: function () {} };

  if (!isHls(url, options.provider)) {
    video.src = url;
    return noop;
  }

  if (typeof window.Hls !== 'undefined' && Hls.isSupported()) {
    var hls = new Hls(Object.assign({}, HLS_CONFIG, { autoStartLoad: !options.lazy }));
    var started = !options.lazy;

    hls.loadSource(url);
    hls.attachMedia(video);

    hls.on(Hls.Events.ERROR, function (event, data) {
      if (!data.fatal) return;
      if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
        hls.recoverMediaError();
        return;
      }
      hls.destroy();
      onError();
    });

    return {
      hls: hls,
      startLoad: function () {
        if (started) return;
        started = true;
        hls.startLoad();
      },
      destroy: function () {
        hls.destroy();
      },
    };
  }

  if (video.canPlayType('application/vnd.apple.mpegurl')) {
    video.src = url;
    return noop;
  }

  throw new Error('HLS is not supported in this browser.');
}

module.exports = { attachSource: attachSource, isHls: isHls };
